
const 	$ = jQuery;

$(document).on('facetwp-loaded', function () {

	const filterBlocks = document.querySelectorAll('.js-filter-block');

	if ( filterBlocks ) {

		[...filterBlocks].forEach( item => {
			
			const filterBlockWrap = item.querySelector('.facetwp-facet'); 

			if ( filterBlockWrap && filterBlockWrap.childElementCount <= 1 ) {
				item.classList.add('hidden');
			}
		});
	}

});

